import { __ } from '@/hub-shared/utils/i18n';

const looksLikeStackOrDump = (s: string): boolean =>
  /\n\s*at\s+/.test(s) || /\bSyntaxError\b/.test(s) || s.length > 800;

const localizeKnownServerMessage = (message: string, status: number): string => {
  if (/insufficient permission to manage cabinet report theme/i.test(message)) {
    return __('Vous n\'avez pas l\'autorisation de gérer le thème du cabinet.');
  }

  if (
    status === 403
    && message.length > 0
    && !/[àâäéèêëïîôùûüç]/i.test(message)
    && /^[\x20-\x7E]+$/.test(message)
  ) {
    return httpStatusUserMessage(403);
  }

  return message;
};

/** User-facing localized copy for HTTP codes when the body carries no safe message */
export function httpStatusUserMessage(status: number): string {
  switch (status) {
    case 400:
      return __('Requête invalide.');
    case 401:
      return __('Authentification requise ou session expirée.');
    case 402:
      return __('Paiement ou abonnement requis.');
    case 403:
      return __('Accès refusé.');
    case 404:
      return __('Ressource introuvable.');
    case 408:
      return __('Délai dépassé. Réessayez.');
    case 409:
      return __('Conflit : cette action ne peut pas être appliquée dans l’état actuel.');
    case 413:
      return __('Fichier ou contenu trop volumineux.');
    case 415:
      return __('Format non pris en charge.');
    case 422:
      return __('Données invalides.');
    case 429:
      return __('Trop de requêtes. Patientez puis réessayez.');
    default:
      if (status >= 500) {
        return __('Le service est momentanément indisponible. Réessayez plus tard.');
      }
      return __('Une erreur est survenue.');
  }
}

/**
 * Parses a typical WP REST JSON error body.
 * Prefer server `message` when present (expects WP locale); never returns raw `HTTP nnn` text.
 */
export const parseApiError = async (response: Response): Promise<string> => {
  try {
    const payload = (await response.json()) as { message?: string; data?: { message?: string } };
    const fromRoot = typeof payload.message === 'string' ? payload.message.trim() : '';
    const fromData = typeof payload.data?.message === 'string' ? payload.data.message.trim() : '';
    const m = fromRoot || fromData;
    if (m.length > 0 && !looksLikeStackOrDump(m)) {
      return localizeKnownServerMessage(m, response.status);
    }
  } catch {
    /* non-JSON body */
  }
  return httpStatusUserMessage(response.status);
};
